/**
 * 列表管理页面，用户修改查询条件，但是不进行查询，点击分页时的回显问题
 * 这里将管理页面中的，查询，重置，分页函数进行统一
 *
 * 查询表单命名需要统一：filterForm
 * 请求api函数需要统一：getList
 */

import { cloneDeep } from 'lodash'

export default {
  data() {
    return {
      page: 1,
      size: 10,

      // filterFormCopy 保存每一次查询的filterForm值，作回显使用
      filterFormCopy: {},
      // 保存filterForm的初始值，作重置使用
      filterFormReset: {}
    }
  },

  watch: {
    // 监听page和size值的变化，重新获取数据
    page() {
      this.getList()
    },
    size() {
      this.getList()
    }
  },

  created() {
    // 根据具体页面定义的filterForm初始化filterFormCopy和filterFormReset
    this.defineFormReset()
  },

  methods: {
    // 重新定义filterFormReset
    // 根据具体页面定义的filterForm初始化filterFormCopy和filterFormReset
    defineFormReset() {
      this.filterFormReset = cloneDeep(this.filterForm)
      this.cache()
    },

    // 缓存copy
    cache() {
      this.filterFormCopy = cloneDeep(this.filterForm)
    },

    // 重置
    reset() {
      this.filterForm = Object.assign({}, this.filterFormReset)
      this.filterFormCopy = Object.assign({}, this.filterFormReset)
    },

    // 回显
    epitaxy() {
      this.filterForm = Object.assign({}, this.filterFormCopy)
    },

    // 点击搜索
    handleSearch() {
      this.cache()
      const oldPage = this.page
      this.page = 1

      if (oldPage === this.page) {
        this.getList()
      }
    },

    // 点击重置
    handleReset() {
      this.reset()

      this.handleSearch()
    }
  }
}
